
    import './styles.scoped.css';
    export default {
  "visible-content": "awsui_visible-content_tc96w_1gnl3_153",
  "visible-content-toggle": "awsui_visible-content-toggle_tc96w_1gnl3_154",
  "visible-content-groups": "awsui_visible-content-groups_tc96w_1gnl3_155",
  "visible-content-group": "awsui_visible-content-group_tc96w_1gnl3_155",
  "visible-content-title": "awsui_visible-content-title_tc96w_1gnl3_160",
  "visible-content-group-label": "awsui_visible-content-group-label_tc96w_1gnl3_170",
  "visible-content-option": "awsui_visible-content-option_tc96w_1gnl3_176",
  "visible-content-option-label": "awsui_visible-content-option-label_tc96w_1gnl3_189",
  "content-display-option-toggle": "awsui_content-display-option-toggle_tc96w_1gnl3_212",
  "content-display-option-content": "awsui_content-display-option-content_tc96w_1gnl3_216",
  "content-display-option": "awsui_content-display-option_tc96w_1gnl3_212",
  "content-display-option-label": "awsui_content-display-option-label_tc96w_1gnl3_264",
  "drag-handle-wrapper": "awsui_drag-handle-wrapper_tc96w_1gnl3_271",
  "content-display": "awsui_content-display_tc96w_1gnl3_212",
  "content-display-text-filter": "awsui_content-display-text-filter_tc96w_1gnl3_276",
  "content-display-no-match": "awsui_content-display-no-match_tc96w_1gnl3_277",
  "content-display-title": "awsui_content-display-title_tc96w_1gnl3_281",
  "content-display-description": "awsui_content-display-description_tc96w_1gnl3_290",
  "content-display-option-list": "awsui_content-display-option-list_tc96w_1gnl3_298",
  "root": "awsui_root_tc96w_1gnl3_305",
  "modal-root": "awsui_modal-root_tc96w_1gnl3_306",
  "trigger-button": "awsui_trigger-button_tc96w_1gnl3_307",
  "cancel-button": "awsui_cancel-button_tc96w_1gnl3_308",
  "confirm-button": "awsui_confirm-button_tc96w_1gnl3_309",
  "custom": "awsui_custom_tc96w_1gnl3_310",
  "content-before": "awsui_content-before_tc96w_1gnl3_311",
  "second-column-small": "awsui_second-column-small_tc96w_1gnl3_315",
  "wrap-lines": "awsui_wrap-lines_tc96w_1gnl3_319",
  "striped-rows": "awsui_striped-rows_tc96w_1gnl3_320",
  "content-density": "awsui_content-density_tc96w_1gnl3_321",
  "page-size": "awsui_page-size_tc96w_1gnl3_322",
  "page-size-form-field": "awsui_page-size-form-field_tc96w_1gnl3_323",
  "page-size-radio-group": "awsui_page-size-radio-group_tc96w_1gnl3_324",
  "sticky-columns": "awsui_sticky-columns_tc96w_1gnl3_325",
  "sticky-columns-form-field": "awsui_sticky-columns-form-field_tc96w_1gnl3_326",
  "sticky-columns-radio-group": "awsui_sticky-columns-radio-group_tc96w_1gnl3_327",
  "sticky-columns-first": "awsui_sticky-columns-first_tc96w_1gnl3_328",
  "sticky-columns-last": "awsui_sticky-columns-last_tc96w_1gnl3_329"
};
  